import { Collection } from 'backbone';
import { getLogger } from '../logging/logger';

const logger = getLogger('HwpCollection');

/**
 * @template {Backbone.Model} M
 * @extends {Collection<M>}
 */
export default class HwpCollection extends Collection {
	/**
	 * @param {Record<string, any>} response
	 */
	parse(response) {
		logger.log(`[parse]`, { response });

		if (response.data) {
			// Our default property name front content sheets.
			return response.data;
		}

		const firstArrayProperty = Object.values(response).find((value) => Array.isArray(value));
		return firstArrayProperty || response;
	}
}
